<section class="calendar-page">
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>
  <div class="message success" *ngIf="successMessage">{{ successMessage }}</div>

  <header class="calendar-page-header">
    <div>
      <h1>Календарь</h1>
      <p>Расписание и задачи команды</p>
    </div>
  </header>

  <section class="calendar-layout">
    <section class="calendar-surface" [class.loading]="loading" aria-label="Календарь месяца">
      <header class="calendar-panel-header">
        <div class="month-navigation" aria-label="Навигация по месяцам">
          <button class="icon-button" type="button" title="Предыдущий месяц" aria-label="Предыдущий месяц" (click)="showPreviousMonth()">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>
          </button>
          <button class="icon-button" type="button" title="Следующий месяц" aria-label="Следующий месяц" (click)="showNextMonth()">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg>
          </button>
          <h2>{{ monthLabel }}</h2>
        </div>
        <button class="today-button" type="button" (click)="showCurrentMonth()">Сегодня</button>
      </header>

      <div class="calendar-scroll">
        <div class="weekday-row">
          <span *ngFor="let weekday of weekdayNames">{{ weekday }}</span>
        </div>

        <div class="month-grid">
          <div
            *ngFor="let day of calendarDays"
            class="day-cell"
            role="button"
            tabindex="0"
            [class.outside-month]="!day.isCurrentMonth"
            [class.today]="day.isToday"
            [class.selected]="day.dateKey === selectedDateKey"
            (click)="selectDay(day)"
            (keyup.enter)="selectDay(day)"
          >
            <span class="day-number">{{ day.dayNumber }}</span>
            <span class="entry-list">
              <button
                *ngFor="let entry of day.entries; trackBy: trackById"
                class="entry-chip"
                type="button"
                [class]="'entry-chip priority-' + entry.priority"
                (click)="openDetails($event, entry)"
              >
                <b>{{ formatEntryTime(entry) }}</b>
                <em>{{ entry.title }}</em>
              </button>
            </span>
          </div>
        </div>
      </div>
    </section>

    <aside class="calendar-sidebar">
      <section class="sidebar-panel selected-day-panel">
        <header class="sidebar-panel-header">
          <div>
            <h2>{{ formatSelectedDate() }}</h2>
            <span>{{ selectedEntries.length }} {{ selectedEntries.length === 1 ? 'событие' : 'событий' }}</span>
          </div>
          <button class="add-day-button" type="button" (click)="openCreate()">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
            <span>Добавить</span>
          </button>
        </header>

        <div class="selected-events" *ngIf="selectedEntries.length; else emptySelectedEvents">
          <button
            *ngFor="let entry of selectedEntries; trackBy: trackById"
            class="sidebar-event"
            type="button"
            [class]="'sidebar-event priority-' + entry.priority"
            (click)="openDetails($event, entry)"
          >
            <span class="event-color"></span>
            <span>
              <strong>{{ entry.title }}</strong>
              <small>{{ formatEntryTime(entry) }}</small>
              <em *ngIf="entry.description">{{ entry.description }}</em>
            </span>
          </button>
        </div>

        <ng-template #emptySelectedEvents>
          <p class="empty-sidebar-state">На этот день событий нет.</p>
        </ng-template>
      </section>

      <section class="sidebar-panel upcoming-panel">
        <header class="sidebar-panel-header">
          <div>
            <h2>Ближайшие события</h2>
          </div>
        </header>

        <div class="upcoming-events" *ngIf="upcomingEntries.length; else emptyUpcomingEvents">
          <button
            *ngFor="let entry of upcomingEntries; trackBy: trackById"
            class="upcoming-event"
            type="button"
            (click)="openDetails($event, entry)"
          >
            <time>{{ formatCompactDate(entry.startsAt) }}</time>
            <span>
              <strong>{{ entry.title }}</strong>
              <small>{{ formatEntryTime(entry) }}</small>
            </span>
          </button>
        </div>

        <ng-template #emptyUpcomingEvents>
          <p class="empty-sidebar-state">Ближайших событий нет.</p>
        </ng-template>
      </section>
    </aside>
  </section>

  <div class="modal-backdrop" *ngIf="modal">
    <section class="calendar-modal" [class.details-modal]="modal === 'details'" role="dialog" aria-modal="true" [attr.aria-label]="modal === 'create' ? 'Новое событие' : 'Детали события'">
      <header class="modal-header">
        <h2>{{ modal === 'create' ? 'Новое событие' : selectedEntry?.title }}</h2>
        <button class="icon-button" type="button" title="Закрыть" aria-label="Закрыть" (click)="closeModal()">
          <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m18 6-12 12"/><path d="m6 6 12 12"/></svg>
        </button>
      </header>

      <form *ngIf="modal === 'create'" class="calendar-form" (ngSubmit)="saveEntry()">
        <label class="wide">
          <span>Название события</span>
          <input class="form-control" name="calendarTitle" [(ngModel)]="formData.title" placeholder="Например, встреча с командой" required>
        </label>
        <label>
          <span>Дата события</span>
          <input class="form-control" type="date" name="calendarDate" [(ngModel)]="formData.date" required>
        </label>
        <label>
          <span>Важность</span>
          <select class="form-select" name="calendarPriority" [(ngModel)]="formData.priority">
            <option *ngFor="let option of priorityOptions" [ngValue]="option.value">{{ option.label }}</option>
          </select>
        </label>
        <label>
          <span>Начало</span>
          <input class="form-control" type="time" name="calendarStart" [(ngModel)]="formData.startsAt" required>
        </label>
        <label>
          <span>Конец</span>
          <input class="form-control" type="time" name="calendarEnd" [(ngModel)]="formData.endsAt" required>
        </label>
        <label class="wide">
          <span>Краткое описание</span>
          <textarea class="form-control" name="calendarDescription" [(ngModel)]="formData.description" rows="4" placeholder="Детали события"></textarea>
        </label>
        <div class="modal-actions wide">
          <button class="secondary-button" type="button" (click)="closeModal()">Отмена</button>
          <button class="primary-button" type="submit" [disabled]="saving">{{ saving ? 'Сохраняем...' : 'Добавить событие' }}</button>
        </div>
      </form>

      <div class="entry-details" *ngIf="modal === 'details' && selectedEntry">
        <span class="priority-pill" [class]="'priority-pill priority-' + selectedEntry.priority">{{ getPriorityName(selectedEntry.priority) }}</span>
        <dl>
          <div>
            <dt>Дата</dt>
            <dd>{{ formatEntryDate(selectedEntry.startsAt) }}</dd>
          </div>
          <div>
            <dt>Время</dt>
            <dd>{{ formatEntryTime(selectedEntry) }}</dd>
          </div>
        </dl>
        <div class="entry-description" *ngIf="selectedEntry.description">
          <span>Описание</span>
          <p>{{ selectedEntry.description }}</p>
        </div>
        <div class="modal-actions">
          <button class="danger-button" type="button" (click)="deleteSelectedEntry()">
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h18"/><path d="M8 6V4h8v2"/><path d="m19 6-1 14H6L5 6"/></svg>
            <span>Удалить событие</span>
          </button>
          <button class="secondary-button" type="button" (click)="closeModal()">Закрыть</button>
        </div>
      </div>
    </section>
  </div>
</section>
